import { render } from "./HistoryList.vue?vue&type=template&id=6ccdc189&scoped=true"
import script from "./HistoryList.vue?vue&type=script&lang=js"
export * from "./HistoryList.vue?vue&type=script&lang=js"

import "./HistoryList.vue?vue&type=style&index=0&id=6ccdc189&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccdc189"]])

export default __exports__